<template>
  <div class="admin">
    <div class="admin__breadcrumbs" v-if="breadcrumbs.length">
      <div class="admin__breadcrumb" v-for="(breadcrumb, index) in breadcrumbs" :key="breadcrumb.title">
        <div class="note" v-if="index !== 0">></div>
        <div class="note">
          <router-link v-if="breadcrumb.route" :to="breadcrumb.route">
            {{ breadcrumb.title }}
          </router-link>
          <span v-else>{{ breadcrumb.title }}</span>
        </div>
      </div>
    </div>
    <div class="admin__title">
      <div class="admin__company">
        <div class="page__header">
          <h1 class="admin__company-name">{{ contextHeading }}</h1>
        </div>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import fetchResources from '@/mixins/fetch-resources';

export default {
  name: 'admin-header',

  mixins: [fetchResources],

  data() {
    return {
      resources: [
        {
          name: 'Company', dependant: 'Workflow', dependantKey: 'company_id', setActive: true,
        },
      ],
    };
  },

  computed: {
    ...mapGetters('admin', [
      'activeCompany',
      'activeWorkflow',
      'activeScreen',
      'activeField',
      'lastSearchTerm',
    ]),

    breadcrumbs() {
      const breadcrumbRoutes = [];
      const pageTitleByRoute = {
        'admin-new-workflow': 'Add Workflow',
        'admin-clone-company-workflow': 'Clone Workflow',
        'admin-preview-workflow': 'Preview Workflow',
        'admin-new-screen': 'Add Screen',
        'admin-new-field': 'Add Field',
        'admin-edit-company': 'Edit Company',
      };
      const pageTitleFromResourceByRoute = {
        'admin-edit-company-workflow': this.activeWorkflow.title,
        'admin-edit-workflow': this.activeWorkflow.title,
        'admin-edit-screen': this.activeScreen.title,
        'admin-edit-field': this.activeField.title,
      };

      const inCompanyContext = !!this.contextCompanyId;
      const inCompanyWorkflowContext = inCompanyContext && this.$route.name !== 'admin-edit-company';
      const inGlobalWorkflowContext = !!this.$route.params.globalWorkflowId;
      const inScreenContext = !!this.$route.params.screenId;

      breadcrumbRoutes.push({
        title: 'Admin',
      });

      if (inCompanyContext) {
        breadcrumbRoutes.push({
          route: {
            name: 'admin-dashboard',
            query: this.companySearchQuery,
          },
          title: this.activeCompany.name || 'Company',
        });

        if (inCompanyWorkflowContext) {
          breadcrumbRoutes.push({
            route: {
              name: 'admin-workflows',
              params: { companyId: this.contextCompanyId },
              query: this.termQuery,
            },
            title: 'Workflows',
          });
        }
      } else {
        breadcrumbRoutes.push({
          route: {
            name: 'admin-dashboard',
            query: {},
          },
          title: 'Global workflows',
        });
      }

      if (inGlobalWorkflowContext && this.activeWorkflow.id) {
        breadcrumbRoutes.push({
          route: {
            name: 'admin-screens',
            params: { globalWorkflowId: this.activeWorkflow.id },
            query: this.termQuery,
          },
          title: this.activeWorkflow.title,
        });
      }

      if (inScreenContext && this.activeScreen.id) {
        breadcrumbRoutes.push({
          route: {
            name: 'admin-fields',
            params: { screenId: this.activeScreen.id },
            query: this.termQuery,
          },
          title: this.activeScreen.title,
        });
      }

      const pageTitle = pageTitleFromResourceByRoute[this.$route.name] || pageTitleByRoute[this.$route.name];
      if (pageTitle && breadcrumbRoutes[breadcrumbRoutes.length - 1]?.title !== pageTitle) {
        breadcrumbRoutes.push({ title: pageTitle });
      }

      if (breadcrumbRoutes.length > 0) {
        delete breadcrumbRoutes[breadcrumbRoutes.length - 1].route;
      }

      return breadcrumbRoutes;
    },

    termQuery() {
      const term = this.$route.query.term || this.lastSearchTerm;
      return term ? { term } : null;
    },

    companySearchQuery() {
      const companyTerm = this.activeCompany.name || this.$route.query.term || this.lastSearchTerm;
      return companyTerm ? { term: companyTerm } : {};
    },

    contextCompanyId() {
      const routeCompanyId = parseInt(this.$route.params.companyId, 10);
      const queryCompanyId = parseInt(this.$route.query.companyId, 10);
      const workflowCompanyId = parseInt(this.activeWorkflow.company_id, 10);
      return routeCompanyId || queryCompanyId || workflowCompanyId || 0;
    },

    contextHeading() {
      return this.contextCompanyId ? (this.activeCompany.name || 'Company') : 'Global workflows';
    },
  },
};
</script>
